import { render } from "./CompanyHome.vue?vue&type=template&id=0b6585bc&scoped=true"
import script from "./CompanyHome.vue?vue&type=script&lang=js"
export * from "./CompanyHome.vue?vue&type=script&lang=js"

import "./CompanyHome.vue?vue&type=style&index=0&id=0b6585bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6585bc"]])

export default __exports__